import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiServiceName } from '@core/api/enums/controllers';
import { SnackbarService } from '@core/services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ValidationErrorInterceptor implements HttpInterceptor {
  private readonly allowedMethods = ['post', 'put', 'delete'];
  private readonly allowedEndpointPrefixes: ApiServiceName[] = [
    ApiServiceName.Technology,
    ApiServiceName.Manufactory,
    ApiServiceName.Machinery,
    ApiServiceName.CapacityPlanning,
  ];

  private readonly snackbarService = inject(SnackbarService);
  protected readonly translateService = inject(TranslateService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith('http')) return next.handle(request);
    const url = new URL(request.url);
    const isRequestMethodAllowed = this.allowedMethods.find(p => p === request.method.toLocaleLowerCase());
    const canProcessEndpoint = this.allowedEndpointPrefixes.some(prefix => {
      let pathname = url.pathname;
      if (url.pathname.startsWith('/api')) pathname = url.pathname.substring(4, url.pathname.length);
      return pathname.startsWith(`/${prefix}`);
    });
    if (isRequestMethodAllowed && canProcessEndpoint) {
      return next.handle(request).pipe(
        catchError((err: HttpErrorResponse) => {
          const errorProperties = err.error?.error_properties;
          const errorMessage = err.error?.error_message;
          const errorCode = err.error?.error_code;

          if (errorCode) {
            const errorTranslated = this.translateErrorMessage(errorCode, errorMessage || '', errorProperties);
            this.snackbarService.addMessage({ message: errorTranslated, iconType: 'error' });
          }
          throw err;
        }),
      );
    } else {
      return next.handle(request);
    }
  }

  private translateErrorMessage(errorCode: string, errorMessage: string, params: any) {
    if (errorCode) {
      const erroTranslation = this.translateService.instant('errors.' + errorCode, params);
      if (erroTranslation && erroTranslation !== errorCode) {
        return erroTranslation;
      }
    }
    return errorMessage;
  }
}
